import * as React from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { MenuItemKey } from '../../components/MainMenu'
import { AppAction } from '../../config/appConfig'
import BaseTaskOverview, { BaseTaskOverviewProps } from '../Task/BaseTaskOverview'
import { FileAction } from '../../config/fileConfig'

export default function GlobalTaskOverview(props: BaseTaskOverviewProps) {
    const dispatch = useDispatch()

    //Reset breadcrumbs and data
    useEffect(() => {
        dispatch({ type: AppAction.SetBreadcrumbs, payload: [props.breadcrumb ?? MenuItemKey.Tasks] })
        dispatch({ type: FileAction.ResetCurrent })
    }, [])

    return <BaseTaskOverview {...props} localStorageKeyPrefix={'HammockGlobalTaskOverview'} />
}
